import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import Grid from "@mui/material/Grid2";
import ProgressBar from "./ProgressBar";
import WeeklyProgressBar from "./WeeklyProgressBar";
import Task from "./Task";
import FocusArea from "./FocusArea";
import CommonFocusArea from "../../../components/CommonFocusArea";
import { palette, theme as colorTheme} from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";

const primary = colorTheme('palette', 'primary').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;

const focusAreas = [
  {
    id: 1,
    title: "Tone Consistency",
    description:
      "Needs immediate attention. Your tone score varies significantly across different call types.",
    backgroundColor: "#ffebee",
    iconColor: negative,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-red-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        ></path>
      </svg>
    ),
    bdColor: "rgb(254 226 226 / var(--tw-border-opacity, 1))",
  },
  {
    id: 2,
    title: "Silence Duration",
    description:
      "Average silence duration is trending upward. Focus on minimizing hold times.",
    backgroundColor: "#fff8e1",
    iconColor: "rgb(234 179 8 / var(--tw-text-opacity, 1))",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-red-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        ></path>
      </svg>
    ),
    bdColor: "rgb(254 249 195 / var(--tw-border-opacity, 1))",
  },
  {
    id: 3,
    title: "Empathy Score",
    description:
      "Great improvement! Your empathy score has increased by 15% this month.",
    backgroundColor: "#e8f5e8",
    iconColor: positive,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-green-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        ></path>
      </svg>
    ),
    bdColor: "rgb(220 252 231 / var(--tw-border-opacity, 1))",
  },
];
function DailyTask() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    // <>
    //   <Box
    //     sx={{
    //        ml: {
    //       xs: "0px",
    //       md: "230px",
    //     },
    //       p: 3,
    //       display: "flex",
    //       flexDirection: "column",
    //       gap: 2,
    //     }}
    //   >
      
    //   </Box>
    // </>

    <ParentWrapper>
        <Grid container spacing={2.5} sx={{}}>
          <Grid item size={{ xs: 12 }} sx={{}}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: isMobile ? "column" : "row",
                mb: 3,
              }}
            >
              <Box>
                {/* <Typography
                  variant="h5"
                  sx={{
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    fontWeight: 700,
                  }}
                  gutterBottom
                >
                  Daily Tasks
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  Your personalized improvement plan for today
                </Typography> */}
                 <Header title={"Daily Tasks"} subHeading={"Your personalized improvement plan for today"} />
              </Box>
            </Box>
          </Grid>
          <Grid item size={{ xs: 8 }}>
            <Grid container spacing={2.5}>
              <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
                <ProgressBar />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
                <Task />
              </Grid>
            </Grid>
          </Grid>
          <Grid item size={{ xs: 4 }}>
            <Grid container spacing={2.5}>
              <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
                <WeeklyProgressBar />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
                <CommonFocusArea focusAreas={focusAreas} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
    </ParentWrapper>
  );
}

export default DailyTask;
